import store from "../store";
import { loadSsoConfig, mustUseSsoOnly, redirectToSsoLogin } from "../helper/sso";
import { isAgencySocialSite } from "../config/agencyRuntime";
function rememberPostLoginRedirect(to) {
    if (typeof window === "undefined" || !to)
        return;
    const path = String(to.fullPath || "");
    if (!path.startsWith("/pm/"))
        return;
    try {
        sessionStorage.setItem("post_login_redirect", path);
    }
    catch {
        /* ignore */
    }
}
export default async function auth({ next, router, to, }) {
    if (store.getters.isAuthenticated) {
        return next();
    }
    rememberPostLoginRedirect(to);
    const cfg = await loadSsoConfig();
    if (cfg && cfg.enabled) {
        try {
            const boot = await store.dispatch("bootstrapSso");
            if (boot && boot.status) {
                return next();
            }
        }
        catch {
            /* SSO session không có — tiếp tục login legacy nếu được phép */
        }
        if (mustUseSsoOnly(cfg)) {
            redirectToSsoLogin(cfg);
            return;
        }
    }
    if (typeof window !== "undefined" && isAgencySocialSite()) {
        return router.push({ name: "AgencyLogin" });
    }
    return router.push({ name: "Login" });
}
